module.exports = __webpack_public_path__ + "static/img/zip.3b922415.png";